import axios from "axios";
import { API_BASE_URL } from '../config';

/**
 * Đăng nhập với Firebase (qua server để che API key)
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<{idToken: string, refreshToken: string, localId: string, email: string}>}
 */
function login(email, password, deviceToken = null, deviceInfo = null) {
  return axios.post(
    `${API_BASE_URL}/api/auth/login`,
    {
      email,
      password,
      deviceToken,
      deviceInfo
    }
  ).then(res => {
    if (res.data.success) {
      return {
        idToken: res.data.idToken,
        refreshToken: res.data.refreshToken,
        localId: res.data.localId,
        email: res.data.email,
        uid: res.data.uid
      };
    } else {
      throw new Error(res.data.message || 'Đăng nhập thất bại');
    }
  }).catch(error => {
    // Xử lý lỗi từ server
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  });
}

/**
 * Đăng ký tài khoản mới (qua server để che API key)
 * @param {string} email 
 * @param {string} password 
 * @returns {Promise<{idToken: string, refreshToken: string, localId: string, email: string}>}
 */
function register(email, password, deviceToken = null, deviceInfo = null) {
  return axios.post(
    `${API_BASE_URL}/api/auth/register`,
    {
      email,
      password,
      deviceToken,
      deviceInfo
    }
  ).then(res => {
    if (res.data.success) {
      return {
        idToken: res.data.idToken,
        refreshToken: res.data.refreshToken,
        localId: res.data.localId,
        email: res.data.email,
        uid: res.data.uid
      };
    } else {
      throw new Error(res.data.message || 'Đăng ký thất bại');
    }
  }).catch(error => {
    // Xử lý lỗi từ server
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  });
}

/**
 * Refresh token (qua server để che API key)
 * @param {string} refreshToken 
 * @returns {Promise<{idToken: string, refreshToken: string}>}
 */
function refreshToken(refreshToken) {
  return axios.post(
    `${API_BASE_URL}/api/auth/refresh-token`,
    {
      refreshToken
    }
  ).then(res => {
    if (res.data.success) {
      return {
        idToken: res.data.idToken,
        refreshToken: res.data.refreshToken
      };
    } else {
      throw new Error(res.data.message || 'Refresh token thất bại');
    }
  }).catch(error => {
    // Xử lý lỗi từ server
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  });
}

/**
 * Quên mật khẩu - Gửi email reset password (qua server để che API key)
 * @param {string} email 
 * @returns {Promise<{success: boolean, message: string}>}
 */
function forgotPassword(email) {
  return axios.post(
    `${API_BASE_URL}/api/auth/forgot-password`,
    {
      email
    }
  ).then(res => {
    if (res.data.success) {
      return {
        success: true,
        message: res.data.message || 'Đã gửi link reset mật khẩu đến email của bạn'
      };
    } else {
      throw new Error(res.data.message || 'Gửi email reset mật khẩu thất bại');
    }
  }).catch(error => {
    // Xử lý lỗi từ server
    if (error.response?.data) {
      throw error.response.data;
    }
    throw error;
  });
}

export const firebase_api = {
  login,
  register,
  refreshToken,
  forgotPassword
};

